import { action } from "typesafe-actions";

import { message } from "antd";

import { GatePayload } from "../../common_types";

import { FilteredAirlinesWidgetActionTypes } from "./types";

export const fetchRequest = (payload: GatePayload) => action(FilteredAirlinesWidgetActionTypes.FETCH_REQUEST, payload);

export const fetchSuccess = (payload: { lastUpdated: string; items: string[] }) =>
  action(FilteredAirlinesWidgetActionTypes.FETCH_SUCCESS, payload);

export const fetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(FilteredAirlinesWidgetActionTypes.FETCH_ERROR);
};
